import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CategoryTotal } from '../../models/search-result';

@Component({
    selector: 'celine-threshold-search-category-filter',
    template: require('./search-category-filter.component.html')
})

export class SearchCategoryFilterComponent {
    @Input() categoryFilter: Array<CategoryTotal>;
    @Output() filterChanged = new EventEmitter<Array<CategoryTotal>>();

    constructor() {
    }

    get allItemsChecked() {
        return !this.categoryFilter.some(category => category.checked === true);
    }

    get allItemsCount() {
        return this.categoryFilter.reduce((a, b) => ({ name: '', checked: false, count: (a.count + b.count) })).count;
    }

    onChange(event: { category: string, checked: boolean}) {
        this.categoryFilter.find(cat => cat.name === event.category).checked = event.checked;
        this.filterChanged.emit(this.categoryFilter);
    }

    onAllItemsChange(state: boolean) {
        if (state === true) {
            this.categoryFilter.forEach(category => category.checked = false);
        }            

        this.filterChanged.emit(this.categoryFilter);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/search/search-category-filter.component.ts